import ServiceBase from "base/baseService"
import { boolToNumber, } from "helper/formater"

export default class UnidadeService extends ServiceBase {

    title = "Unidade"
    pluralTitle = "Unidades"
    url = '/cadastro/produto/unidade'
    frontUrl = '/cadastro/produto/unidade'
    frontUrlList = '/cadastro/produto/unidadelist'
    primaryKey = 'codigo_unid'
    // icon = 'pi pi-server'

    prepareToFront(data = {}) {

        data.eh_conj_unid = boolToNumber(data.eh_conj_unid, true)
        data.eh_frac_unid = boolToNumber(data.eh_frac_unid, true)

        return data
    }

    prepareToSave({ data }) {

        data.eh_conj_unid = boolToNumber(data.eh_conj_unid)
        data.eh_frac_unid = boolToNumber(data.eh_frac_unid)

        delete data.meta

        return data

    }

}
